export default "__VITE_ASSET__0cfd8e82__"